import { Container, Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { ButtonHLPure } from '../../pures'
import LabelPure from '../../pures/label/label.pure'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import InputPureWrapper from '../onboarding/steps/inputs/inputPureWrapper'
import { Checkbox } from '@progress/kendo-react-inputs'
import NumericTextboxWrapper from './components/numeric-textbox-wrapper'
import TimepickerWrapper from './components/timepicker-wrapper'
import BotTemplateDropdownWrapper from './components/bot-template-dropdown-wrapper'
import { requiredValidator } from './components/validator'
import { useTranslation } from 'react-i18next'

const ChatbotConfigurationGeneralView = (props) => {
  const {
    initialData,
    saveData,
    botTemplates
  } = props

  const { t } = useTranslation('chatbot', { keyPrefix: 'configuration' })
  const { t: tCommon } = useTranslation('common')

  const [formKey, setFormKey] = useState(1)
  const resetForm = () => setFormKey(formKey + 1)

  useEffect(() => {
    resetForm()
  }, [initialData])

  return (
    <Container maxWidth={'md'}>
      <Form
        key={`chatbot-configuration-${formKey}`}
        initialValues={initialData}
        onSubmit={saveData}
        render={(formRenderProps) => {
          return (
            <FormElement>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    id='chatbotName'
                    name={'chatbotName'}
                    component={InputPureWrapper}
                    label={t('generalData.chatbotName')}
                    validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('generalData.startTime')} editorId='startTime' />
                  <Field
                    id='startTime'
                    name={'startTime'}
                    component={TimepickerWrapper}
                    validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('generalData.endTime')} editorId='endTime' />
                  <Field
                    id='endTime'
                    name={'endTime'}
                    component={TimepickerWrapper}
                    validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('generalData.sessionsPerDay')} editorId='sessionsPerDay' />
                  <Field
                    id='sessionsPerDay'
                    name={'sessionsPerDay'}
                    component={NumericTextboxWrapper}
                    validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div title={t('generalData.maxTimeSession')} style={{ cursor: 'help' }}>
                    <LabelPure title={t('generalData.maxTimeSession')} editorId='maxTimeSession' />
                  </div>
                  <Field
                    id='maxTimeSession'
                    name={'maxTimeSession'}
                    component={NumericTextboxWrapper}
                    validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id='botTemplateId'
                    name={'botTemplateId'}
                    component={BotTemplateDropdownWrapper}
                    label={t('generalData.botTemplate')}
                    placeholder={t('generalData.botTemplatePlaceholder')}
                    data={botTemplates}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id='allowGeolocation'
                    name={'allowGeolocation'}
                    component={Checkbox}
                    label={t('generalData.allowGeolocation')}
                  />
                </Grid>
                <Grid item xs={12} className='button-actions'>
                  {
                    formRenderProps.modified &&
                    <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('cancel')} onClick={() => {
                      resetForm()
                    }} />
                  }
                  <ButtonHLPure primary nameBtn={tCommon('save')} type='submit' />
                </Grid>
              </Grid>
            </FormElement>
          )
        }}
      />
    </Container>
  )
}

export default ChatbotConfigurationGeneralView